import * as Yup from 'yup';

const UpdateProfileSchema = Yup.object().shape({
    name: Yup.string()
        .min(4, 'Too short')
        .max(30, 'Too long')
        .required('Name is required'),
    email: Yup.string()
        .email('Invalid email')
        .required('Email is required'),
    newEmail: Yup.string()
        .email('Email address is not valid.')
        .required('Email address is required.'),
    newEmailConfirm: Yup.string()
        .email('Email address is not valid.')
        .required('Email address is required.'),
});

export default UpdateProfileSchema;
